<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->

        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-card class="box no-display">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Invoice Report</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="section" item-value="id"
                            :items="sectionListAll" item-text="name" label="Section" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="standard" item-value="id"
                            :items="standardListAll" @change="getDivisions(standard)" item-text="standard"
                            label="Standard" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="division" item-value="id"
                            :items="divisionListAll" item-text="division" label="Division" outlined />
                    </v-col>
                </v-row>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="order" item-value="id"
                            :items="orderStatusListAll" item-text="name" label="Order Status" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="deliveryoption" item-value="id"
                            :items="deliveryOptionListAll" item-text="name" label="Delivery Option" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete rounded dense required v-model="vendorShop" :items="vendorShopListAll"
                            item-text="name" item-value="id" label="Delivery Shop" outlined
                            persistent-hint></v-autocomplete>

                    </v-col>





                </v-row>
                <v-row justify="center" dense>

                    <v-col cols="12" sm="3" md="3">
                        <strong>Date</strong>
                        <v-icon color="error">*</v-icon>
                        <v-radio-group v-model="date" mandatory row>
                            <v-radio label="All" :value="false" color="#0f2027"></v-radio>
                            <v-radio label="Date Range" :value="true" color="#0f2027"></v-radio>

                        </v-radio-group>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" v-if="this.date == true">
                        <strong>From Date</strong>
                        <v-icon color="error">*</v-icon>
                        <v-text-field outlined dense type="date" v-model="fromdate" hint="From Date"></v-text-field>
                        <span>(Inclusive)</span>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" v-if="this.date == true">
                        <strong>To Date</strong>
                        <v-icon color="error">*</v-icon>
                        <v-text-field outlined dense type="date" v-model="todate" hint="To Date"></v-text-field>

                        <span>(Inclusive)</span>
                    </v-col>

                </v-row>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3" class="pt-7">
                        <v-btn class="button" @click="getReport()" :loading="loader">Fetch
                            Report</v-btn>
                    </v-col>
                </v-row>
            </v-card>

            <!-- <span v-if="mainList != '' && mainList != null"> -->
            <v-card v-if="invoice_report_list.length > 0">
                <v-card-title>
                    <v-btn v-if="invoice_report_list != '' && invoice_report_list != null" class="ml-2 mt-5 no-display"
                        rounded color="success" outlined @click="fnExcelReport('my-table-id', 'InvoiceReport')"
                        :loading="loader">
                        <v-icon color="success">mdi-export</v-icon>Export
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                        hide-details></v-text-field>
                </v-card-title>
                <v-data-table v-if="invoice_report_list.length > 0" :headers="headers1" :items="invoice_report_list"
                    :search="search" class="elevation-1" id="my-table-id">
                    <template v-slot:[`item.invoice_no`]="{ item }">
                        <span>{{ item.invoice_no }}</span>
                        <span>
                            <v-icon @click="showInvoice(item)" color="green">mdi-eye</v-icon>
                        </span>
                    </template>
                </v-data-table>
            </v-card>
            <!-- </span> -->




            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>




        </v-container>

    </div>

</template>
<script>
import axios from "axios";
import "@/assets/css/color.css";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({

        loader: false,
        snackbar_msg: "",
        // extraBreadcrumbItems: [
           

        // ],
        // breadcrumbClass: "breadcrumb-style1",
        search: "",
        basepath: null,
        section: null,
        standard: null,
        division: null,
        order: null,
        deliveryoption: null,
        vendorShop: null,
        color: "",
        snackbar: false,
        overlay: false,
        orderStatusListAll: [],
        deliveryOptionListAll: [],
        vendorShopListAll: [],
        sectionListAll: [],
        standardListAll: [],
        divisionListAll: [],
        invoice_report_list: [],
        show_logo: true,
        date: false,
        fromdate: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2).toISOString().substr(0, 10),
        todate: new Date().toISOString().slice(0, 10),
        headers1: [
            {
                text: "Sr. No.",
                value: "srno",
            },
            {
                text: "Invoice No",
                align: "center",
                value: "invoice_no",
            },
            {
                text: "Order Id",
                align: "center",
                value: "order_id",
            },
            {
                text: "Order Date",
                align: "center",
                value: "order_date",
            },
            {
                text: "PRN",
                align: "center",
                value: "prn",
            },
            {
                text: "Student Name",
                align: "center",
                value: "student_name",
            },
            {
                text: "Section",
                align: "center",
                value: "section",
            },
            {
                text: "Standard",
                align: "center",
                value: "standard",
            },
            {
                text: "Division",
                align: "center",
                value: "division",
            },
            {
                text: "Total Amount",
                align: "center",
                value: "total_amount",
            },
            {
                text: "Order Status",
                align: "center",
                value: "order_status",
            },
            {
                text: "Approval Status",
                align: "center",
                value: "approval_status",
            },
            {
                text: "Delivery Option",
                align: "center",
                value: "delivery_option",
            },
            {
                text: "Pickup Address",
                align: "center",
                value: "pickup_address",
            },
            {
                text: "Approval Date",
                align: "center",
                value: "approval_date",
            },
        ],

    }),
    methods: {

        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table border='1px'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            //Save the file
            // var blob = new Blob([tab_text], {
            //     type: "application/vnd.ms-excel;charset=utf-8",
            // });
            // window.saveAs(blob, fileName);
            const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const filename = name + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        showLogo() {
            if (this.show_logo) {
                this.show_logo = false;
            } else {
                this.show_logo = true;
            }
        },
        showInvoice(item) {
            localStorage.setItem("invoice_id", item.invoice_id);
            let routeData = this.$router.resolve({ name: "view-invoice-edustore" });
            window.open(routeData.href, "_blank");
        },
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        getReport() {
            this.loader = true;
            this.invoice_report_list = [];
            const data = {
                section: this.section,
                standard: this.standard,
                division: this.division,
                order: this.order,
                deliveryoption: this.deliveryoption,
                vendorShop: this.vendorShop,
                date: this.date,
                fromdate: this.fromdate,
                todate: this.todate,
            };
            axios
                .post("/EduStore/fetchInvoiceReport", data)
                .then((res) => {
                    if (res.data.flag == "Yes") {
                        this.invoice_report_list = res.data.invoice_report_list;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.loader = false;
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.loader = false;
                })
                .finally(() => { });
        },
        onLoad() {
            axios
                .post("/EduStore/getInvoiceReport")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.orderStatusListAll = res.data.orderStatusListAll;
                        this.deliveryOptionListAll = res.data.deliveryOptionListAll;
                        this.vendorShopListAll = res.data.vendorShopListAll;
                        this.sectionListAll = res.data.sectionListAll;
                        this.standardListAll = res.data.standardListAll;
                        this.divisionListAll = res.data.div_off_list;

                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => { });
        },
        getDivisions(standard) {

            const data = {

                standard: standard,
            };
            this.overlay = true;
            axios
                .post("/EduStore/getDivisionOfferings", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.divisionListAll = res.data.div_off_list
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    //  this.onerror(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    // this.selected_date=""
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        this.onLoad();
        this.basepath = localStorage.getItem("awspath");
    },
    watch: {},
};
</script>
<style scoped>
tr,
td,
th {
    border: 1px solid #ccc;
    width: auto;
    font-size: small;
}

@media print {

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    /* img {
    width: 100% !important;
  } */

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    .box {
        background-color: white !important;
        /* margin: 8px !important;
    padding: 8px; */
        border: none !important;
        /* overflow: hidden !important; */
    }

    @page {
        size: A4;
        margin-top: none !important;
        padding-top: none;
        /* size: 18in 17in; */
        size: 20in 17in;
    }
}
</style>
